import React, { useContext, useEffect, useState } from 'react'
import {
  Form,
  FormField,
  Grid,
  GridRow,
  GridColumn,
  Button,
} from 'semantic-ui-react'
import * as yup from 'yup'
import Swal from 'sweetalert2'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { CustomerViewContext } from '../customer-info-view/customerView'
import {
  updateCustomerSettings,
  getCustomerSettings,
} from '../../../../services/customer'
import styles from './customerSettings.module.css'

const arabicRegex = /[\u0600-\u06FF]/

const formValidator = {
  email: yup.string().trim().required('Email is required').email(),
}

const CommunicationSettings = () => {
  const product = localStorage.getItem('product')
  const { customerSettings, setViewNetworkSettings } =
    useContext(CustomerViewContext)
  const { register, handleSubmit, errors, setValue } = useForm({
    resolver: yupResolver(yup.object().shape(formValidator)),
  })

  const [mailError, setMailError] = useState(false)

  useEffect(() => {
    ;(async () => {
      Swal.showLoading()
      try {
        const queryParams = {
          product,
          id: customerSettings.tbCustomerId,
        }
        console.log(queryParams)
        const res = await getCustomerSettings(queryParams)
        res.data.map((attr) => {
          const key = attr.id.attributeKey
          console.log(key)
          if (key in formValidator) {
            setValue(key, attr.strValue)
          }
          if (key === 'e-mail') setValue('email', attr.strValue)
          return null
        })
        Swal.close()
        console.log(res)
      } catch (e) {
        console.log(e)
        Swal.fire('Error Grabing Customer Settings', '', 'error')
      }
    })()
  }, [])

  const addEmail = async (data) => {
    console.log(data)
    if (arabicRegex.test(data.email)) {
      setMailError(true)
      return
    }
    setMailError(false)
    const queryParams = {
      product,
      id: customerSettings.tbCustomerId,
    }
    console.log(queryParams)
    Swal.showLoading()
    try {
      await updateCustomerSettings(queryParams, data)
      await Swal.fire({
        title: 'Email Updated Successfully',
        icon: 'success',
        confirmButtonColor: 'Green',
      })
      setViewNetworkSettings(false)
    } catch (e) {
      Swal.fire('Something Went Wrong', '', 'error')
      console.log(e)
    }
  }
  return (
    <>
      <Form
        style={{
          backgroundColor: 'rgb(216, 231, 234)',
          padding: 10,
          borderRadius: 9,
        }}
        onSubmit={handleSubmit(addEmail)}
        id="commSettings"
      >
        <h3 className={styles.formHeader}>Customer Email</h3>
        <FormField>
          <Grid columns={3}>
            <GridRow>
              <GridColumn>
                <FormField>
                  <span>Email:</span>
                  <input
                    name="email"
                    ref={register}
                    type="text"
                    placeholder="Email"
                    onChange={(e) => {
                      if (!arabicRegex.test(e.target.value)) setMailError(false)
                    }}
                  />
                  <small style={{ color: 'red' }}>**</small>
                  {errors.email && (
                    <p style={{ color: 'red' }}>{errors.email.message}</p>
                  )}

                  {mailError && (
                    <p style={{ color: 'red' }}>
                      Email can not contain arabic letters
                    </p>
                  )}
                </FormField>
              </GridColumn>
            </GridRow>
          </Grid>
          <hr />
          <Grid>
            <Grid.Column textAlign="center">
              <Button
                from="config form"
                type="submit"
                className={styles.button}
                style={{ backgroundColor: '#5cb85c', color: '#FFF' }}
              >
                Save
              </Button>
            </Grid.Column>
          </Grid>
        </FormField>
      </Form>
    </>
  )
}

export default CommunicationSettings
